import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getServiceIdSelector } from '../../user/selectors'
import { OptionsService } from '../services/options.service'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'
import { setDynamicRangeOptions } from '../store/options.actions'
import { IOptions } from '../../../common/common.types'

function* handleSetOptions(path: string, options: IOptions) {
  yield put(setDynamicRangeOptions(path, options))
}

function* getDynamicOptions() {
  const serviceId = yield select(getServiceIdSelector)
  const optionsService = new OptionsService(serviceId)
  try {
    const response = yield call([optionsService, optionsService.getNumberRangeOptions]) // Assuming the method is same for all
    const { entity } = response

    for (const optionValues of entity) {
      const values = optionValues as any
      const range = []
      for (let i = values.min; values.inclusive ? i <= values.max : i < values.max; i++) {
        if (!values.skipValues || !values.skipValues.includes(i)) {
          range.push({ id: i, name: i.toString() })
        }
      }
      yield call(handleSetOptions, values.objectPathInState, range)
    }
  } catch (e) {
    yield put(throwPcrException(`getDynamicOptions() error: ${e}`))
  }
}

export function* getDynamicOptionsSaga() {
  yield takeLatest(ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS, getDynamicOptions)
}
